/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { MedicineResponseInOrderDto } from './MedicineResponseInOrderDto';
import {
    MedicineResponseInOrderDtoFromJSON,
    MedicineResponseInOrderDtoFromJSONTyped,
    MedicineResponseInOrderDtoToJSON,
    MedicineResponseInOrderDtoToJSONTyped,
} from './MedicineResponseInOrderDto';

/**
 * 
 * @export
 * @interface MedicineInOrderResponseDto
 */
export interface MedicineInOrderResponseDto {
    /**
     * Medicine details
     * @type {MedicineResponseInOrderDto}
     * @memberof MedicineInOrderResponseDto
     */
    medicine: MedicineResponseInOrderDto;
    /**
     * SIG (Instruction) - Dose/Unit/Route/Frequency/Direction/Duration
     * @type {string}
     * @memberof MedicineInOrderResponseDto
     */
    sig: string;
    /**
     * Dispense quantity
     * @type {number}
     * @memberof MedicineInOrderResponseDto
     */
    dispense: number;
    /**
     * Number of refills allowed
     * @type {number}
     * @memberof MedicineInOrderResponseDto
     */
    refill: number;
}

/**
 * Check if a given object implements the MedicineInOrderResponseDto interface.
 */
export function instanceOfMedicineInOrderResponseDto(value: object): value is MedicineInOrderResponseDto {
    if (!('medicine' in value) || value['medicine'] === undefined) return false;
    if (!('sig' in value) || value['sig'] === undefined) return false;
    if (!('dispense' in value) || value['dispense'] === undefined) return false;
    if (!('refill' in value) || value['refill'] === undefined) return false;
    return true;
}

export function MedicineInOrderResponseDtoFromJSON(json: any): MedicineInOrderResponseDto {
    return MedicineInOrderResponseDtoFromJSONTyped(json, false);
}

export function MedicineInOrderResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): MedicineInOrderResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'medicine': MedicineResponseInOrderDtoFromJSON(json['medicine']),
        'sig': json['sig'],
        'dispense': json['dispense'],
        'refill': json['refill'],
    };
}

export function MedicineInOrderResponseDtoToJSON(json: any): MedicineInOrderResponseDto {
    return MedicineInOrderResponseDtoToJSONTyped(json, false);
}

export function MedicineInOrderResponseDtoToJSONTyped(value?: MedicineInOrderResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'medicine': MedicineResponseInOrderDtoToJSON(value['medicine']),
        'sig': value['sig'],
        'dispense': value['dispense'],
        'refill': value['refill'],
    };
}

